import { Button, Col, Row, Space, Form, Input, Card } from "antd";
import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import {
  addUser,
  getUserDetailsData,
  updateUser,
} from "../../../redux/action/user-management/userManagementAction";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

const AddUser = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const isEditMode = location.pathname.includes("edit");

  const userDetails = useSelector((store) => store.getUserDetails?.dataDetails);
  const { isLoading } = useSelector((store) => store.getUserDetails);

  useEffect(() => {
    if (isEditMode && params?.id) {
      dispatch(getUserDetailsData(params.id));
    }
  }, [isEditMode, params?.id, dispatch]);

  useEffect(() => {
    if (isEditMode && userDetails && Object.keys(userDetails).length > 0) {
      form.setFieldsValue(userDetails);
    }
  }, [isEditMode, userDetails, form]);

  const handleSubmit = async () => {
   
    try {
     
      const values = await form.validateFields();
      
      if (isEditMode) {
        await dispatch(updateUser(params?.id, values, () => navigate(-1)));

      } else {
         await dispatch(addUser(values, () => navigate(-1)));
        
      }
     
    } catch (error) {

      console.log( error);
    }
  };

  return (
    <div>
      <div className="addBtnBx dflex">
        <div className="tableHeading">
          {isEditMode ? "Edit User Details" : "Add User Details"}
        </div>
        <Space>
          <Button onClick={() => navigate(-1)}>Cancel</Button>
          <Button type="primary" onClick={handleSubmit}>
            Save Details
          </Button>
        </Space>
      </div>
      <Card loading={isLoading}>
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col xs={24} sm={8}>
              <Form.Item
                name="name_en"
                label="User’s Full Name (en)"
                rules={[{ required: true, message: "Please enter full name" }]}
              >
                <Input size="large" placeholder="Enter user’s full name" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item
                name="email"
                label="User’s Email Address"
                rules={[
                  { required: true, message: "Please enter an email address" },
                  { type: "email", message: "Please enter a valid email" },
                ]}
              >
                <Input size="large" placeholder="Enter email address" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
};

export default AddUser;
